import { render } from "./ConfigManagerComponent.vue?vue&type=template&id=00925504&scoped=true&ts=true"
import script from "./ConfigManagerComponent.vue?vue&type=script&lang=ts"
export * from "./ConfigManagerComponent.vue?vue&type=script&lang=ts"

import "./ConfigManagerComponent.vue?vue&type=style&index=0&id=00925504&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00925504"]])

export default __exports__